import { render, staticRenderFns } from "./orderitem.vue?vue&type=template&id=30917f3b&lang=pug"
import script from "./orderitem.vue?vue&type=script&lang=coffee"
export * from "./orderitem.vue?vue&type=script&lang=coffee"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports